import React, { Fragment } from "react";
import { Switch, Route, Redirect } from "react-router-dom";

import AppHeader from "../../Layout/AppHeader";
import AppSidebar from "../../Layout/AppSidebar";
import AppFooter from "../../Layout/AppFooter";
// Pages
import PortfolioDashboard from "./PortfolioDashboard";
import AccountDashboard from "./AccountDashboard";
import TradeDetail from "../trading/TradeDetail";
import StrategySummary from "../strategy/StrategySummary";
import OrderHistory from "../trading/OrderHistory";
import PnLPage from "../trading/PnLPage";
import ReconciliationPage from "../trading/ReconciliationPage";

import StrategyBuild from "../strategy/StrategyBuild";
import StrategyJobs from "../strategy/StrategyJobs";
import StrategyManage from "../strategy/StrategyManage";

import RuleBuilderPage from "../rules/RuleBuilderPage";
import RuleTemplatesPage from "../rules/RuleTemplatesPage";
import SystemSettingsPage from "../settings/SystemSettingsPage";
import ProfilePage from "../profile/ProfilePage";
import NotificationsPage from "../profile/NotificationsPage";
import AdminPage from "../admin/AdminPage";
import SystemHealthPage from "../admin/SystemHealthPage";
import AuditPage from "../admin/AuditPage";
import PriceAlertsPage from "../alerts/PriceAlertsPage";
import SuggestionsPage from "../automation/SuggestionsPage";
import HistoryPage from "../automation/HistoryPage";
import OrderQueuePage from "../automation/OrderQueuePage";
import ChatPage from "../support/ChatPage";
import AdminChatView from "../support/AdminChatView";
import AdminChatSessionList from "../support/AdminChatSessionList";
import ChatWidget from "../../components/chat/ChatWidget";
import PageHelpBubble from "../../components/chat/PageHelpBubble";
import SubscriptionBanner from "../../components/SubscriptionBanner";
import { ChatProvider } from "../../context/ChatContext";
//import StrategyHistory from "../strategy/StrategyHistory";

const DashboardLayout = () => {
  return (
    <ChatProvider>
    <Fragment>
      <AppHeader />

      <div className="app-main">
        <AppSidebar />

        <div className="app-main__outer">
          <div className="app-main__inner">
            <Switch>
              {/* ===== DASHBOARD ===== */}
              <Route exact path="/dashboard" component={AccountDashboard} />

              {/* ===== STRATEGY ===== */}
              <Route exact path="/strategy/build" component={StrategyBuild} />
              <Route exact path="/strategy/jobs" component={StrategyJobs} />
              <Route exact path="/strategy/manage" component={StrategyManage} />

              {/* ===== RULES ===== */}
              <Route exact path="/rules/builder" component={RuleBuilderPage} />
              <Route exact path="/rules/templates" component={RuleTemplatesPage} />

              {/* ===== SETTINGS ===== */}
              <Route exact path="/system/settings" component={SystemSettingsPage} />

              {/* ===== AUTOMATION ===== */}
              <Route exact path="/automation/suggestions" component={SuggestionsPage} />
              <Route exact path="/automation/history"     component={HistoryPage} />
              <Route exact path="/automation/orders"      component={OrderQueuePage} />

              {/* ===== PROFILE ===== */}
              <Route exact path="/profile" component={ProfilePage} />
              <Route exact path="/profile/notifications" component={NotificationsPage} />

              {/* ===== ADMIN ===== */}
              <Route exact path="/admin/users" component={AdminPage} />
              <Route exact path="/admin/system/health" component={SystemHealthPage} />
              <Route exact path="/admin/audit" component={AuditPage} />
              {/* legacy redirect */}
              <Redirect from="/strategy/rules" to="/rules/builder" />

              {/* ===== ALERTS ===== */}
              <Route exact path="/alerts/price" component={PriceAlertsPage} />

              {/* ===== TRADING ===== */}
              <Route exact path="/trading/positions" component={PortfolioDashboard} />
              <Route exact path="/trading/strategy-summary" component={StrategySummary} />
              <Route exact path="/trading/orders" component={OrderHistory} />
              <Route exact path="/trading/pnl" component={PnLPage} />
              <Route exact path="/trading/reconciliation" component={ReconciliationPage} />
              <Route path="/trading/:stockname" component={TradeDetail} />

              {/* ===== SUPPORT ===== */}
              <Route exact path="/chat" component={ChatPage} />
              <Route exact path="/admin/chat/:sessionId" component={AdminChatView} />
              <Route exact path="/admin/chat" component={AdminChatSessionList} />

              {/* ===== DEFAULT ===== */}
              <Redirect to="/dashboard" />
            </Switch>
          </div>

          <AppFooter />
        </div>
      </div>

      {/* ── subscription expiry bubble — dismissible ── */}
      <SubscriptionBanner />

      {/* ── contextual help bubble — route-aware, top-right ── */}
      <PageHelpBubble />

      {/* ── floating chat widget — always visible on every page ── */}
      <ChatWidget />
    </Fragment>
    </ChatProvider>
  );
};

export default DashboardLayout;
